import {
  BuildingLibraryIcon,
  NewspaperIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/solid";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import EmailRecipient from "./EmailRecipient";
import EmailWorkFlow from "./EmailWorkFlow";
import EmailLogs from "./EmailLogs";
export const EmailTabs = [
  {
    to: ROUTE_PATHS.Utilities_EmailRecipientConfieguration_Index,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Email Recipients",
    component: EmailRecipient,
    permission: PERMISSIONS.permission_utilities_emailrecipient_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmailRecipientConfiegurationWorkFlow_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Email Workflow",
    component: EmailWorkFlow,
    permission: PERMISSIONS.permission_utilities_emailworkflow_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmailLogs_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Email Logs",
    component: EmailLogs,
    permission: PERMISSIONS.permission_utilities_emaillogs_view,
  },
];
